module.exports = __webpack_public_path__ + "img/phone.37a5cc48.svg";